<template>
    <span class="font-bold">
        Prisen er inkl. moms og ekskl. betterhype-gebyr.
        <img
            v-tooltip:top="'betterhype-gebyret bliver lagt oveni, når du har forhandlet den endelige pris med influenceren. Den samlede pris inkl. betterhype-gebyr vil blive vist, når du klikker &quot;accepter&quot;.'"
            src="/img/icons/info.svg"
            alt="info"
            class="inline"
            style="width: 14px; height: 14px;"
        >
    </span>
</template>

<script type="text/babel">
import Tooltip from 'dashboard-js/directives/Tooltip'

export default {
    directives: { Tooltip },
}
</script>
